export default {
  path: "/cashin",
  name: "cashin",
  component: {
    template: `<router-view></router-view>`
  },
  children: [
    //
    {
      path: "cashin",
      name: "cashin/cashin",
      component: () => import("@/components/CashIn/CashIn"),
      meta: {
        can: "admin::main:cash-in"
      }
    },
    {
      path: "bank",
      name: "cashin/bank",
      component: () => import("@/components/CashIn/Bank"),
      meta: {
        can: "admin::main:cash-in-bank"
      }
    },
    {
      path: "online-bank-reconcilate",
      name: "cashin/online-bank-reconcilate",
      component: () => import("@/components/CashIn/OnlineBanks"),
      meta: {
        can: "admin::main:cash-in-online"
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/cash-in.js